module.exports = __webpack_public_path__ + "static/media/logo_navbar.b2f07a29.svg";